import { render, staticRenderFns } from "./shopInfoSetting.vue?vue&type=template&id=fbbee494&scoped=true&"
import script from "./shopInfoSetting.vue?vue&type=script&lang=js&"
export * from "./shopInfoSetting.vue?vue&type=script&lang=js&"
import style0 from "./shopInfoSetting.vue?vue&type=style&index=0&id=fbbee494&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbee494",
  null
  
)

export default component.exports